export enum TrustpilotTags {
    SelectedReview = "SelectedReview",
}
